export enum GlobalSearchStatusEnum {
    initial = "initial",
    searching = "searching",
    doneWithResults = "doneWithResults",
    error = "error",
    doneWithZeroResults = "doneWithZeroResults",
    doneWithTypo = "doneWithTypo",
    doneWithWrongApp = "doneWithWrongApp"
}
